import { expertType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';

export const EXPERTISE_FIELD = {
  EXPERTISE_ID: 'expertiseId',
  VICTIMS: 'victims',
  EXPERTISES: 'expertises',
  VEHICULES: 'vehicules',
  EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID: 'expertiseJudgementAddDocumentId',
} as const;
export const EXPERT_FIELD = {
  NAME: 'expertName',
  DATE: 'expertiseDate',
  ADRESSE: 'address',
} as const;
export const EMPTY_EXPERTISE = {
  [EXPERTISE_FIELD.EXPERTISE_ID]: '',
  [EXPERTISE_FIELD.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID]: '',
  [EXPERTISE_FIELD.VICTIMS]: new Set([]),
  [EXPERTISE_FIELD.EXPERTISES]: new Set() as Set<expertType>,
  [EXPERTISE_FIELD.VEHICULES]: new Set([]),
};

export const EXPERTISES = {
  MEDICAL: '1',
  ACCOUNTING: '2',
  MECHANICAL: '3',
} as const;

export const DOCUMENT = 'Document';
